import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

const Config = {
  apiKey: "AIzaSyBSQbBasPnITq1AT6f40sBWHalvogB9PH4",
    authDomain: "volta-sportscam.firebaseapp.com",
    databaseURL: "https://volta-sportscam.firebaseio.com",
    projectId: "volta-sportscam",
    storageBucket: "volta-sportscam.appspot.com",
    messagingSenderId: "376918914499",
    appId: "1:376918914499:web:3e16af5ceefa0114f93976",
    measurementId: "G-6FWTQ234QR"
};

export const CreateUserProfileDocument = async (userAuth, additionalData) => {
  if (!userAuth) return;

  const userRef = firestore.doc(`users/${userAuth.uid}`);

  const snapShot = await userRef.get();

  if (!snapShot.exists) {
    const { displayName, email } = userAuth;
    const createdAt = new Date();

    try {
      await userRef.set({
        displayName,
        email,
        createdAt,
        ...additionalData
      });
    } catch (error) {
      console.log(`${error} User Can't be registered`);
    }
  }
  return userRef;
};

firebase.initializeApp(Config);

export const auth = firebase.auth();
export const firestore = firebase.firestore();

const provider = new firebase.auth.GoogleAuthProvider();

provider.setCustomParameters({ prompt: "select_account" });
export const signInWithGoogle = () => auth.signInWithPopup(provider);

export default firebase;
